module.exports = __webpack_public_path__ + "img/gamesdk-top-v2.3000b7d.png";